<template>
  <div :class="{ 'mb-9': ((role == 'space_admin' || role == 'booster') && productPlan.attributes && productPlan.attributes.name == 'Pro Trial') || role == 'space_admin' && subscriptionEnds || (role == 'space_admin' && productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due')) }">
    <SystemBarTopTrial v-if="(role == 'space_admin' || role == 'booster') && productPlan.attributes && productPlan.attributes.name == 'Pro Trial'"/>
    <SystemBarTopCancelSubscription v-if="role == 'space_admin' && subscriptionEnds"/>
    <SystemBarTopPaymentFailed v-if="role == 'space_admin' && productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due')"/>
    <v-app-bar
      app
      clipped-left
      elevation="0"
      outlined
      style="z-index:8"
    >
      <v-icon
        data-testid="space-button-list"
        @click="redirectToMySpaces"
      >
        mdi-apps
      </v-icon>
      <v-toolbar-title v-if="!loadingData" class="d-flex">
        <router-link
          v-if="!mobile()"
          to="/"
          class="d-flex text-decoration-none"
        >
          <v-img
            v-if="logo == null"
            data-testid="logo-space"
            src="../assets/rtplogo.svg"
            max-height="40"
            max-width="150"
            class="d-none d-sm-block mx-4 justify-center"
            contain
            position="top left"
          />
          <v-img
            v-else
            data-testid="logo-space"
            :src="logo"
            max-height="40"
            max-width="150"
            class="d-none d-sm-block mx-4 justify-center"
            contain
            position="top left"
          />
          <v-tooltip
          v-if="productPlan.attributes"
          bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-chip  v-bind="attrs"
                v-on="on" v-if="productPlan.attributes && productPlan.attributes.name != 'Business+' && (role == 'booster' || role == 'space_admin')" class="px-2 ma-2 align-self-center text-uppercase" x-small text-color="white"  :class="productPlan.attributes.name == 'Pro Trial' ? 'darktext--text' : 'white--text'" data-testid="space-plan" :color="productPlan.attributes.name == 'Free' ? 'pink':
                                                                                             productPlan.attributes.name == 'Pro' ? 'accent':
                                                                                             productPlan.attributes.name == 'Pro Trial' ? 'anchor20opacity':''
                                                                                             " >{{productPlan.attributes.name}}</v-chip>
            </template>
            <span>{{ $t('subscriptionPlanTooltip', { value: productPlan.attributes.name}) }}</span>
          </v-tooltip>
           <v-tooltip
           v-if="productPlan.attributes"
          bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs"
                v-on="on" v-if="productPlan.attributes && productPlan.attributes.name == 'Business+' && (role == 'booster' || role == 'space_admin')" color="warning">
            mdi-crown-circle
          </v-icon>
            </template>
            <span>{{ $t('subscriptionPlanTooltip', { value: productPlan.attributes.name}) }}</span>
          </v-tooltip>
          
                                                                               
        </router-link>
        <router-link
          v-else
          to="/"
          class="d-flex text-decoration-none"
        >
          <v-img
            v-if="icon == null"
            data-testid="logo-space"
            src="../assets/rtpicon.png"
            max-height="40"
            max-width="40"
            class="mx-4 justify-center"
            contain
            position="top left"
          />
          <v-img
            v-else
            data-testid="logo-space"
            :src="icon"
            max-height="40"
            max-width="40"
            class="mx-4 justify-center"
            contain
            position="top left"
          />
          <v-tooltip
          v-if="productPlan.attributes"
          bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-chip  v-bind="attrs"
                v-on="on" v-if="productPlan.attributes && productPlan.attributes.name != 'Business+' && (role == 'booster' || role == 'space_admin')" class="px-2 ma-2 align-self-center text-uppercase" x-small text-color="white"  :class="productPlan.attributes.name == 'Pro Trial' ? 'darktext--text' : 'white--text'" data-testid="space-plan" :color="productPlan.attributes.name == 'Free' ? 'pink':
                                                                                             productPlan.attributes.name == 'Pro' ? 'accent':
                                                                                             productPlan.attributes.name == 'Pro Trial' ? 'anchor20opacity':''
                                                                                             " >{{productPlan.attributes.name}}</v-chip>
            </template>
            <span>{{ $t('subscriptionPlanTooltip', { value: productPlan.attributes.name}) }}</span>
          </v-tooltip>
           <v-tooltip
           v-if="productPlan.attributes"
          bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs"
                v-on="on" v-if="productPlan.attributes && productPlan.attributes.name == 'Business+' && (role == 'booster' || role == 'space_admin')" color="warning">
            mdi-crown-circle
          </v-icon>
            </template>
            <span>{{ $t('subscriptionPlanTooltip', { value: productPlan.attributes.name}) }}</span>
          </v-tooltip>
                                                                                             
        </router-link>                       
      </v-toolbar-title>
      <v-spacer />

      <NotificationCenter />

      <ContactUs v-if="(role == 'booster' || role == 'space_admin') && space!='id'" />

      <v-tooltip
        bottom
      >
        <template v-slot:activator="{ on }">
          <span 
          class="d-none d-sm-block mx-2" 
          v-on="on"
        >
          <router-link
            v-if="space == 'id'"
            to="profile"
            class="text-decoration-none darktext--text"
          >{{ first_name }} {{ last_name }}</router-link>
          <router-link
            v-else
            to="#"
            class="text-decoration-none darktext--text"
            @click.native="redirectToProfile"
          >{{ first_name }} {{ last_name }}</router-link>
        </span>
        </template>
        <span>{{ $t('profile') }}</span>
      </v-tooltip>

      <v-tooltip
        bottom
      >
        <template v-slot:activator="{ on }">
          <span 
          v-on="on"
        >
          <router-link
            v-if="space == 'id'"
            to="profile"
          >
            <v-avatar
              size="38"
              class="mx-2"
            >
              <img
                v-if="avatar == null"
                src="../assets/user_images/profile-avatar.png"
              >
              <img
                v-else
                :src="avatar"
              >
            </v-avatar>
          </router-link>
          <router-link
            v-else
            to="#"
            @click.native="redirectToProfile"
            v-on="on"
          >
            <v-avatar
              v-if="!loadingData"
              size="38"
              class="mx-2"
            >
              <img
                v-if="avatar == null"
                src="../assets/user_images/profile-avatar.png"
              >
              <img
                v-else
                :src="avatar"
              >
            </v-avatar>
          </router-link>
        </span>
        </template>
        <span>{{ $t('profile') }}</span>
      </v-tooltip>

      
      <v-menu
        offset-y
        flat
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
          >
            <v-icon
              v-if="menu == false"
              data-testid="menu-closed-button"
              large
              @click="menu=false"
            >
              mdi-menu-down
            </v-icon>
            <v-icon
              v-else
              data-testid="menu-open-button"
              large
              @click="menu=true"
            >
              mdi-menu-up
            </v-icon>
          </v-btn>
        </template>
        <v-list data-testid="menu-list">
          <v-list-item
            router
            class="logout"
            data-testid="logout-item"
            @click="logout"
          >
            <v-list-item-title class="pr-2">
              {{ $t('signOut') }}
            </v-list-item-title>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>     
  </div>
</template>
<script>
import {eventBus} from '../eventbus'
import { logoutAuth} from '../auth/auth.js'
import i18n from '../plugins/i18n'
import { logoutUser } from '../api/userApi'
import ContactUs from '../components/ContactUs'
import NotificationCenter from '../components/NotificationCenter'
import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin'
import SystemBarTopTrial from '../components/SystemBarTopTrial';
import SystemBarTopCancelSubscription from '../components/SystemBarTopCancelSubscription'
import SystemBarTopPaymentFailed from '../components/SystemBarTopPaymentFailed'

export default {
      components: { 
        ContactUs,
        SystemBarTopTrial,
        SystemBarTopCancelSubscription,
        SystemBarTopPaymentFailed,
        NotificationCenter
    },
  mixins: [repeatedMethodsMixin],
    data(){
        return{
            menu: false,
            first_name: localStorage.user ? JSON.parse(localStorage.user).first_name : '',
            last_name: localStorage.user ? JSON.parse(localStorage.user).last_name : '',
            avatar: localStorage.user ? JSON.parse(localStorage.user).avatar_thumb : null,
            user_menu_items: [
                { icon:'mdi-exit-to-app', text: 'logout', route: '/logout' },
            ],
            userId: window.$cookies.get('id'),
            spaceId: window.$cookies.get('space_id'),
            space: window.location.host.split('.')[0],
            logo: localStorage.space ? JSON.parse(localStorage.space).logo : null,
            icon: localStorage.space ? JSON.parse(localStorage.space).icon : null,
            role: localStorage.space ? JSON.parse(localStorage.space).role : '',
            loadingData: false,
            subscriptionEnds: localStorage.space? JSON.parse(localStorage.space).subscription_ends_at: '',
        }
        
    },
    computed:{
        productPlan() {
            return this.$store.state.productPlan;
        }
    },

    async created () {
        eventBus.$on('changeAvatar',()=>{
            this.avatar = JSON.parse(localStorage.user).avatar_thumb
        })
        eventBus.$on('changeLogo',(action)=>{
            if(action == 'downgradePlan'){
                this.logo = null
            }else {
                this.logo = JSON.parse(localStorage.space).logo
            }
        })
        
        eventBus.$on('changeUserData',()=>{
            this.first_name = JSON.parse(localStorage.user).first_name
            this.last_name = JSON.parse(localStorage.user).last_name
        })

        
    },
    beforeDestroy() {
        eventBus.$off('changeAvatar')
        eventBus.$off('changeLogo')
        eventBus.$off('changeUserData')
    },
    methods: {
        async logout(){
            try {
                const response = await logoutUser()
                if(response.status == 200) {
                    logoutAuth()
                    this.$router.push({path: '/login'})
                }
            } catch (e) {
                this.error= i18n.t('serverError')
            }
        },
        redirectToMySpaces(){
            if(this.space == 'id'){
                this.$router.push({path: '/spaces'})
            }else {
                window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/spaces"
            }
        },
        redirectToProfile(){
            window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/profile"
        }
    }
}
</script>